import { render, staticRenderFns } from "./WorkshopDetailClientsGridCpt.vue?vue&type=template&id=461944ba&scoped=true&"
import script from "./WorkshopDetailClientsGridCpt.vue?vue&type=script&lang=ts&"
export * from "./WorkshopDetailClientsGridCpt.vue?vue&type=script&lang=ts&"
import style0 from "./WorkshopDetailClientsGridCpt.vue?vue&type=style&index=0&id=461944ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461944ba",
  null
  
)

export default component.exports